import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	go: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.go',
		defaultMessage: 'Go',
		description: 'Label for the "Go" button to run a new search',
	},
	back: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.back',
		defaultMessage: 'Back - Exit Atlassian Intelligence',
		description: 'Label for the "Back" button to exit a search',
	},
	backRovo: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.back-rovo',
		defaultMessage: 'Back - Exit Rovo',
		description: 'Label for the "Back" button to exit a search (Rovo variant)',
	},
});
